<template>
  <v-container fluid>
    <page-title icon="fas fa-fw fa-fax">
      New Fax Snippet
    </page-title>

    <v-form @submit.prevent="submit">
      <v-card>
        <v-card-text>
          <fax-snippet-form :form="form">
          </fax-snippet-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary"
                 type="submit">
            Submit
          </v-btn>

          <v-btn @click.prevent="$router.back()">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

  </v-container>
</template>
<script>
import Form from 'vform';
import faxService from '../../../../services/faxService';
import FaxSnippetForm from './components/FaxSnippetForm';
import PageTitle from '../../../../components/PageTitle.vue';

export default {
  components: {PageTitle, FaxSnippetForm},
  data() {
    return {
      busy: false,
      form: new Form({
        name: '',
        content: '',
        is_active: true,
      }),
      source: null,
    }
  },
  computed: {
    sourceID() {
      if (this.$route.query.source) {
        return parseInt(this.$route.query.source);
      }
      return null;
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      if (this.busy) {
        return;
      }
      this.busy = true;
      if (this.sourceID) {
        faxService.getFaxSnippet(this.sourceID)
          .then(data => {
            this.form.name = `${data.name} - COPY`;
            this.form.content = data.content;
            this.form.is_active = data.is_active;
          })
      }
    },
    submit() {
      if (this.form.busy) {
        return;
      }
      faxService.createFaxSnippet(this.form)
        .then(data => {
          this.form.reset();
          this.$toast.success('Fax Snippet created.');
          this.$router.push({name: 'admin.fax_snippets.index'});
        })
    }
  },
}
</script>
